<p class="textSubHeader" style="margin: 16px 0 16px 0;">
     Mi perfil
</p>

<p class="textHeader" style="margin-bottom: 16px;">
     Mis planes y convenios
</p>
<ng-container *ngIf="usuario._id">
     <app-plans [usuario]="usuario" ></app-plans>
</ng-container>